import { getLimitDate } from "util/date";
import moment from "moment";

export const cleanEcheqObject = (echeqAction) => {
    let echeqListObject = [];
    let quantity = 0;
    if (!echeqAction.echeqList) {
        return echeqAction;
    }

    // I´m cleaning some keys from the json because of the length in extended_data
    const currency = echeqAction.echeqList[0]?.moneda || "ARS";
    echeqAction.echeqList.forEach((echeqJson) => {
        const object = { ...echeqJson };
        delete object.firmantes;
        delete object.avalistas;
        delete object.endosos;
        delete object.rechazos;
        delete object.cesiones;

        echeqListObject = [...echeqListObject, object];

        quantity += object.monto;
    });

    return { ...echeqAction, echeqList: echeqListObject, amount: { currency, quantity } };
};

// Emitedd echecks initial filter
export const today = moment().toDate();
export const date365DaysBefore = getLimitDate(-365);
export const date365DaysAfter = getLimitDate(365);
export const date30DaysBefore = getLimitDate(-30);

// Received echeck initial filters
export const date7DaysBefore = getLimitDate(-7);
export const date7DaysAfter = getLimitDate(7);

// Determina si un listado de transacciones tiene operaciones con error y exitoso
export const isFinishedWithErrors = (transactions) => {
    const isError = transactions?.find((e) => e?.error == "error");
    const isSuccess = transactions?.find((e) => e?.error == "success");
    return isError && isSuccess;
};

export default cleanEcheqObject;
